import React, { Fragment } from "react"
import { Container, Hidden, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { graphql, useStaticQuery } from "gatsby"
import notionRendererFactory from "gatsby-source-notionso/lib/renderer"
import NotionBlockRenderer from "components/notionBlockRenderer"
import SEO from "components/gatsby/SEO"
import Footer from "components/Footer"
import Chips from "components/Chips"
import "assets/styles/md-styles.css"

interface Props {
  data: any
}

const useStyles = makeStyles({
  container: {
    marginTop: "50px",
  },
})

const IndividualBlog: React.FC<Props> = ({ data }) => {
  const classes = useStyles()
  const notionRenderer = notionRendererFactory({
    notionPage: data.notionPageBlog,
  })

  // console.log(data.allNotionPageBlog)

  return (
    <Fragment>
      <SEO
        title={data.notionPageBlog.title}
        image={data.notionPageBlog.imageNodes[0].localFile.publicURL}
      />
      <Chips />
      <Container maxWidth="md" className={classes.container}>
        <NotionBlockRenderer
          data={data}
          renderer={notionRenderer}
          debug={false}
        />
      </Container>
      <Footer />
    </Fragment>
  )
}

export default IndividualBlog

export const query = graphql`
  query($pageId: String!) {
    allNotionPageBlog {
      edges {
        node {
          createdAt
          pageId
          title
          slug
        }
      }
    }
    notionPageBlog(pageId: { eq: $pageId }) {
      createdAt
      pageId
      slug
      title
      isDraft
      id
      indexPage
      blocks {
        blockId
        blockIds
        type
        attributes {
          att
          value
        }
        properties {
          propName
          value {
            text
            atts {
              att
              value
            }
          }
        }
      }
      imageNodes {
        imageUrl
        localFile {
          publicURL
        }
      }
    }
  }
`
